<template>
  <div style="position: relative">
    <div class="title">
      <span class="vertical-bar fn18 fnM" style="line-height: 32px">表单（{{com.config.moduleName}}）</span>
      <div class="table-btns">
        <el-button type="primary" @click="extFieldAddDialog.show=true">添加扩展字段</el-button>
        <el-button type="primary" @click="jsonEditor.show=true">
          {{jsonEditor.readOnly?"查看JSON代码":"编辑JSON代码"}}
        </el-button>
      </div>
    </div>
    <el-dialog
      title="表单"
      class="source_dialog code_source_dialog"
      :visible.sync="jsonEditor.show"
      :destroy-on-close="true"
      :close-on-click-modal="false"
      @open="onJsonEditorDialogOpen"
      @closed="onJsonEditorDialogClosed"
    >
      <div class="editor">
        <CodeMirrorEditor ref="jsonEditor" v-model="jsonEditor.data" :readOnly="jsonEditor.readOnly" @save="onJsonEditorDialogSave"></CodeMirrorEditor>
      </div>
      <div class="footer" v-if="!jsonEditor.readOnly">
        <el-button @click="onJsonEditorDialogCancel">取消</el-button>
        <el-button type="primary" @click="onJsonEditorDialogSave(jsonEditor.data)">保存</el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="添加扩展字段"
      class="source_dialog code_source_dialog"
      :visible.sync="extFieldAddDialog.show"
      :destroy-on-close="true"
      :close-on-click-modal="false"
      @open="onExtFieldAddDialogOpen"
      @closed="onExtFieldAddDialogClosed"
    >
      <div class="form">
        <el-form ref="refForm" :model="extFieldAddDialog.model" :rules="extFieldAddDialog.rules" label-position="top">
          <el-row :gutter="100">
            <el-col :span="12">
              <el-form-item label="选择字段" prop="prop">
                <div style="display: flex">
                  <div style="flex: 1">
                    <el-select v-model="extFieldAddDialog.model.prop" placeholder="请选择字段" clearable :style="{width:'100%'}">
                      <el-option v-for="field in filteredExtFieldForAdd" :label="field" :value="field" :key="field"></el-option>
                    </el-select>
                  </div>
                  <div v-if="extFieldAddDialog.model.prop=='其它'" style="flex: 2">
                    <el-form-item prop="customProp">
                      <el-input v-model="extFieldAddDialog.model.customProp" placeholder="请输入字段名称"></el-input>
                    </el-form-item>
                  </div>
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <div v-if="extFieldAddDialog.model.prop=='其它'">
                <el-form-item label="组件类型" prop="component" key="select">
                  <el-select
                    v-model="extFieldAddDialog.model.component"
                    placeholder="请选择组件类型"
                    clearable
                    :style="{width:'100%'}"
                  >
                    <el-option label="文字输入框" value="string"></el-option>
                    <el-option label="整数输入框" value="int"></el-option>
                    <el-option label="浮点数输入框" value="float"></el-option>
                    <el-option label="日期输入框" value="date"></el-option>
                  </el-select>
                </el-form-item>
              </div>
              <div v-else>
                <el-form-item label="组件类型" key="input">
                  <el-input v-model="extFieldAddDialogComponentText" disabled></el-input>
                </el-form-item>
              </div>
            </el-col>
            <el-col :span="12">
              <el-form-item label="组件显示名称" prop="label">
                <el-input v-model="extFieldAddDialog.model.label" placeholder="请输入"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="是否隐藏" prop="hidden">
                <el-select v-model="extFieldAddDialog.model.hidden" clearable placeholder="否" :style="{width:'100%'}">
                  <el-option label="是" :value="true"></el-option>
                  <el-option label="否" :value="false"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="是否为必填项" prop="required">
                <el-select v-model="extFieldAddDialog.model.required" clearable placeholder="否" :style="{width:'100%'}">
                  <el-option label="是" :value="true"></el-option>
                  <el-option label="否" :value="false"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="是否禁用" prop="disabled">
                <el-select v-model="extFieldAddDialog.model.disabled" clearable placeholder="否" :style="{width:'100%'}">
                  <el-option label="是" :value="true"></el-option>
                  <el-option label="否" :value="false"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="显示顺序" prop="order">
                <el-input-number
                  v-model="extFieldAddDialog.model.sys_order"
                  :precision="2"
                  placeholder="未尾"
                  controls-position="right"
                  :min="1"
                  clearable
                ></el-input-number>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24" style="color:gray">
              字段说明：<br>
              <table border="0">
                <tr>
                  <td>extS1 ~ extS8是字符型字段；</td><td>extI1 ~ extI4是整数型字段；</td>
                </tr>
                <tr>
                  <td>extF1 ~ extF4是浮点数型字段；</td><td>extD1 ~ extD4是日期型字段；</td>
                </tr>
              </table>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24" class="footer">
              <el-button @click="extFieldAddDialog.show=false">取消</el-button>
              <el-button type="primary" @click="onExtFieldAddSubmit">确定</el-button>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </el-dialog>

    <el-table :data="data" stripe style="width: 100%" ref="dt" row-key="prop">
      <el-table-column type="index" label="序号" width="80" fixed="left"></el-table-column>
      <el-table-column prop="label" label="组件显示名称">
        <template slot-scope="scope">
          <span v-if="scope.row.sys_mode==='edit'">
            <el-input v-if="scope.row.component=='rc-switch'" v-model="scope.row.attribute.inactiveText" placeholder="请输入内容"></el-input>
            <el-input v-else-if="scope.row.component=='rc-addon-title'" v-model="scope.row.attribute.label" placeholder="请输入内容"></el-input>
            <el-input v-else v-model="scope.row.label" placeholder="请输入内容"></el-input>
          </span>
          <span v-else>
            {{formatter_label(scope.row)}}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="component" label="组件类型" width="180"></el-table-column>
      <el-table-column prop="prop" label="对应字段CODE码"></el-table-column>
      <el-table-column prop="hidden" label="是否隐藏" width="120">
        <template slot-scope="scope">
          <span v-if="scope.row.sys_mode==='edit'">
            <el-select v-model="scope.row.hidden" placeholder="否" clearable>
              <el-option label="是" :value="true"></el-option>
              <el-option label="否" :value="false"></el-option>
            </el-select>
          </span>
          <span v-else>
            {{formatter_hidden(scope.row)}}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="required" label="是否为必填项" width="120">
        <template slot-scope="scope">
          <span v-if="scope.row.sys_mode==='edit' && scope.row.component!=='rc-addon-title'">
            <el-select v-model="scope.row.sys_required" placeholder="否" clearable>
              <el-option label="是" :value="true"></el-option>
              <el-option label="否" :value="false"></el-option>
            </el-select>
          </span>
          <span v-else>
            {{formatter_required(scope.row)}}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="disabled" label="是否禁用" width="120">
        <template slot-scope="scope">
          <span v-if="scope.row.sys_mode==='edit' && scope.row.component!=='rc-addon-title'">
            <el-select v-model="scope.row.attribute.disabled" placeholder="否" clearable>
              <el-option label="是" :value="true"></el-option>
              <el-option label="否" :value="false"></el-option>
            </el-select>
          </span>
          <span v-else>
            {{formatter_disabled(scope.row)}}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="order" label="显示顺序" width="120">
        <template slot-scope="scope">
          <span v-if="scope.row.sys_mode==='edit'">
            <el-input-number v-model="scope.row.sys_order" controls-position="right" :min="1" clearable></el-input-number>
          </span>
          <span v-else>
            {{scope.row.sys_order}}
          </span>
        </template>
      </el-table-column>

      <el-table-column label="操作" fixed="right" width="120">
        <template slot-scope="scope">
          <template v-if="scope.row.sys_mode==='edit'">
            <el-button type="text" class="btn__text--no-padding" @click="onRowSave(scope)">保存</el-button>
            <el-button type="text" class="btn__text--no-padding grey" @click="restoreRowState(scope.$index)">取消</el-button>
          </template>
          <template v-else>
            <el-button type="text" class="btn__text--no-padding" @click="onRowEdit(scope)">编辑</el-button>
            <el-button
              v-if="getRowDelBtnVisibility(scope)"
              type="text"
              class="btn__text--no-padding btn__text--red"
              @click="onRowDel(scope)"
            >删除</el-button>
          </template>
        </template>
      </el-table-column>
    </el-table>
    <div v-show="suspend.synchronizing" class="mask">
      <span class="text"><i class="el-icon-loading"></i></span>
    </div>
  </div>
</template>

<script>
import CodeMirrorEditor from "@/components/common/CodeMirror";
import parser from "@/utils/parser";
import { $isEmptyObject } from "@/utils/helper";

const comsDoNotNeedConfig = ["rc-bridge", "slot"];
export default {
  name: "Form1",
  components: {CodeMirrorEditor},
  inject: ["saveConfig", "getResourceConfigCopy"],
  props: {
    com: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      data: [],
      suspend: {
        synchronizing: false,
        method: "",
        effectRowIndex: NaN
      },
      jsonEditor: {
        show: false,
        data: "",
        readOnly: true
      },
      extFieldAddDialog: {
        show: false,
        rules: {
          prop: [
            { required: true, message: "请选择字段", trigger: ["blur", "change"] }
          ],
          customProp: [
            { required: true, message: "请输入字段名称", trigger: ["blur", "change"] }
          ],
          label: [
            { required: true, message: "请输入组件显示名称", trigger: ["blur", "change"] }
          ],
          component: [
            { required: true, message: "请选择组件类型", trigger: ["blur", "change"] }
          ]
        },
        model: {
          label: "",
          prop: "",
          hidden: false,
          required: undefined,
          disabled: undefined,
          sys_order: undefined,
          component: ""
        }
      },
      extFieldList: [
        "extS1",
        "extS2",
        "extS3",
        "extS4",
        "extS5",
        "extS6",
        "extS7",
        "extS8",
        "extI1",
        "extI2",
        "extI3",
        "extI4",
        "extF1",
        "extF2",
        "extF3",
        "extF4",
        "extD1",
        "extD2",
        "extD3",
        "extD4",
        "其它"
      ]
    };
  },
  computed: {
    filteredExtFieldForAdd() {
      return this.extFieldList.filter(field => this.data.findIndex(col => col.prop === field) === -1);
    },
    extFieldAddDialogComponentText() {
      if (this.extFieldAddDialog.model.prop.startsWith("extS")) {
        return "文字输入框";
      } else if (this.extFieldAddDialog.model.prop.startsWith("extI")) {
        return "整数输入框";
      } else if (this.extFieldAddDialog.model.prop.startsWith("extF")) {
        return "浮点数输入框";
      } else if (this.extFieldAddDialog.model.prop.startsWith("extD")) {
        return "日期输入框";
      } else {
        return "";
      }
    }
  },
  watch: {
    com(newValue, oldValue) {
      this.tableDatasourceConstructor();
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.tableDatasourceConstructor();
    });
  },
  methods: {
    tableDatasourceConstructor() {
      this.data = parser.parse(parser.stringify(this.com.config.formItem))
        .filter(formItemConfig => comsDoNotNeedConfig.findIndex(comName => comName === formItemConfig.component) == -1);

      this.data.forEach((row, index) => {
        this.$set(row, "sys_mode", "view");
        this.$set(row, "sys_order", index + 1);
        this.$set(row, "sys_required", this.getRowRequired(row));
        if (row.attribute === undefined) {
          row.attribute = {};
        }
      });
    },

    formatter_hidden(row) {
      return row.hidden ? "是" : "否";
    },
    formatter_disabled(row) {
      if (row.attribute && row.attribute.disabled) {
        if (row.attribute.disabled) {
          return "是";
        } else {
          return "否";
        }
      } else {
        return "否";
      }
    },
    formatter_required(row) {
      const required = this.getRowRequired(row);
      return required ? "是" : "否";
    },
    getRowRequired(row) {
      if (row.rules) {
        if (row.rules.findIndex(rule => rule.required === true) === -1) {
          return false;
        } else {
          return true;
        }
      } else {
        return false;
      }
    },
    formatter_label(row) {
      switch (row.component) {
        case "rc-switch": {
          return row.attribute.inactiveText;
        }
        case "rc-addon-title": {
          return row.attribute.label;
        }
        case "rc-checkbox":{
          return row.attribute.label;
        }
        default: {
          return row.label;
        }
      }
    },

    onRowEdit(scope) {
      for (let i = 0; i < this.data.length; i++) {
        this.restoreRowState(i);
      }

      this.$set(this.data[scope.$index], "sys_backup", parser.stringify(this.data[scope.$index]));
      this.$set(this.data[scope.$index], "sys_mode", "edit");
    },
    onRowSave(scope) {
      if (scope.row.component !== "rc-bridge") {
        switch (scope.row.component) {
          case "rc-switch": {
            if (scope.row.attribute.inactiveText.trim() === "") {
              this.$message.error("组件显示名称为必填");
              return;
            }
            break;
          }
          case "rc-addon-title": {
            if (scope.row.attribute.label.trim() === "") {
              this.$message.error("组件显示名称为必填");
              return;
            }
            break;
          }
          default: {
            if (scope.row.label.trim() === "") {
              this.$message.error("组件显示名称为必填");
              return;
            }
          }
        }
      }

      if (scope.row.hidden === "") {
        delete scope.row.hidden;
      }
      switch (scope.row.sys_required) {
        case "":
        case false: {
          if (scope.row.rules) {
            const index = scope.row.rules.findIndex(rule => rule.required !== undefined);
            if (index !== -1) {
              scope.row.rules.splice(index, 1);
            }
          }
          break;
        }
        case true: {
          if (scope.row.rules === undefined) {
            scope.row.rules = [];
          }

          const index = scope.row.rules.findIndex(rule => rule.required !== undefined);
          if (index == -1) {
            scope.row.rules.push({
              required: true,
              message: (scope.row.component.includes("input") ? "请输入" : "请选择") + scope.row.label,
              trigger: ["blur", "change"]
            });
          }
          break;
        }
      }
      if (scope.row.attribute.disabled === "") {
        delete scope.row.attribute.disabled;
      }

      this.suspend.synchronizing = true;
      this.suspend.method = "row";
      this.suspend.effectRowIndex = scope.$index;

      const dataCopy = parser.parse(parser.stringify(this.data));
      dataCopy.sort((a, b) => a.sys_order - b.sys_order);
      dataCopy.forEach(row => {
        delete row.sys_mode;
        delete row.sys_backup;
        delete row.sys_order;
        delete row.sys_required;
      });
      const resourceConfigCopy = this.getResourceConfigCopy();
      resourceConfigCopy.componentAttributesMap[this.com.id].formItem = dataCopy;
      this.saveConfig({
        content: parser.stringify(resourceConfigCopy),
        succCallback: this.saveSuccCallback,
        failedCallback: this.saveFailedCallback
      });
    },
    restoreRowState(index) {
      const theRow = this.data[index];

      if (!theRow.sys_backup) {
        return;
      }

      const theRowBackUp = parser.parse(theRow.sys_backup);
      Object.keys(theRowBackUp).forEach(key => {
        theRow[key] = theRowBackUp[key];
      });
      delete theRow.sys_backup;
    },
    onRowDel(scope) {
      this.suspend.synchronizing = true;
      this.suspend.method = "row";
      this.suspend.effectRowIndex = scope.$index;

      const resourceConfigCopy = this.getResourceConfigCopy();
      const delTargetColIndex = resourceConfigCopy.componentAttributesMap[this.com.id].formItem.findIndex(col => {
        return col.prop === scope.row.prop;
      });
      resourceConfigCopy.componentAttributesMap[this.com.id].formItem.splice(delTargetColIndex, 1);
      this.saveConfig({
        content: parser.stringify(resourceConfigCopy),
        succCallback: this.saveSuccCallback,
        failedCallback: this.saveFailedCallback
      });
    },
    getRowDelBtnVisibility(scope) {
      return this.extFieldList.includes(scope.row.prop);
    },

    saveSuccCallback() {
      switch (this.suspend.method) {
        case "row": {
          const theRow = this.data[this.suspend.effectRowIndex];
          delete theRow.sys_backup;
          this.$set(theRow, "sys_mode", "view");
          break;
        }
        case "json": {
          this.tableDatasourceConstructor();
          this.jsonEditor.show = false;
          break;
        }
        case "add": {
          this.tableDatasourceConstructor();
          this.extFieldAddDialog.show = false;
          break;
        }
      }

      this.suspend.synchronizing = false;
      this.suspend.method = "";
      this.suspend.effectRowIndex = NaN;
      this.$message.success("已保存");
    },
    saveFailedCallback(reason) {
      switch (this.suspend.method) {
        case "row": {
          break;
        }
        case "json": {
          break;
        }
        case "add": {
          break;
        }
      }

      this.suspend.synchronizing = false;
      this.suspend.method = "";
      this.suspend.effectRowIndex = NaN;
      this.$message.error(`保存失败:${reason}`);
    },

    onJsonEditorDialogOpen() {
      for (let i = 0; i < this.data.length; i++) {
        this.restoreRowState(i);
      }

      this.jsonEditor.data = parser.stringify(this.com.config.formItem);
    },
    onJsonEditorDialogClosed() {
      this.jsonEditor.data = "";
    },
    onJsonEditorDialogSave(val) {
      this.suspend.synchronizing = true;
      this.suspend.method = "json";
      this.suspend.effectRowIndex = NaN;

      const dataCopy = parser.parse(this.jsonEditor.data);
      const resourceConfigCopy = this.getResourceConfigCopy();
      resourceConfigCopy.componentAttributesMap[this.com.id].formItem = dataCopy;
      this.saveConfig({
        content: parser.stringify(resourceConfigCopy),
        succCallback: this.saveSuccCallback,
        failedCallback: this.saveFailedCallback
      });
    },
    onJsonEditorDialogCancel() {
      this.jsonEditor.show = false;
    },

    onExtFieldAddDialogOpen() {
      for (let i = 0; i < this.data.length; i++) {
        this.restoreRowState(i);
      }
      if (this.$refs.refForm) {
        this.$refs.refForm.clearValidate();
      }
    },
    onExtFieldAddDialogClosed() {
      this.extFieldAddDialog.model.label = "";
      this.extFieldAddDialog.model.prop = "";
      this.extFieldAddDialog.model.hidden = false;
      this.extFieldAddDialog.model.required = undefined;
      this.extFieldAddDialog.model.disabled = undefined;
      this.extFieldAddDialog.model.sys_order = undefined;
    },
    onExtFieldAddSubmit() {
      this.$refs.refForm.validate((valid) => {
        if (valid) {
          const newFormItem = {
            attribute: {},
            rules: []
          };
          Object.keys(this.extFieldAddDialog.model).forEach(field => {
            if (![null, undefined, ""].includes(this.extFieldAddDialog.model[field])) {
              switch (field) {
                case "disabled": {
                  newFormItem.attribute.disabled = this.extFieldAddDialog.model[field];
                  break;
                }
                case "required": {
                  newFormItem.rules.push({
                    message: "请输入" + this.extFieldAddDialog.model.label,
                    required: this.extFieldAddDialog.model[field],
                    trigger: ["blur", "change"]
                  });
                  break;
                }
                case "prop": {
                  newFormItem.prop = this.extFieldAddDialog.model[field];
                  if (newFormItem.prop === "其它") {
                    switch (this.extFieldAddDialog.model.component) {
                      case "string": {
                        newFormItem.component = "rc-input";
                        newFormItem.attribute.placeholder = "请输入";
                        break;
                      }
                      case "int": {
                        newFormItem.component = "rc-input-number";
                        newFormItem.attribute.controlsPosition = "right";
                        newFormItem.attribute.placeholder = "请输入";
                        break;
                      }
                      case "float": {
                        newFormItem.component = "rc-input-number";
                        newFormItem.attribute.controlsPosition = "right";
                        newFormItem.attribute.precision = 2;
                        newFormItem.attribute.placeholder = "请输入";
                        break;
                      }
                      case "date": {
                        newFormItem.component = "rc-date-picker";
                        newFormItem.attribute.placeholder = "请选择日期";
                        break;
                      }
                    }
                    newFormItem.prop = this.extFieldAddDialog.model.customProp;
                  } else {
                    if (newFormItem.prop.startsWith("extS")) {
                      newFormItem.component = "rc-input";
                      newFormItem.attribute.placeholder = "请输入";
                    } else if (newFormItem.prop.startsWith("extI")) {
                      newFormItem.component = "rc-input-number";
                      newFormItem.attribute.controlsPosition = "right";
                      newFormItem.attribute.placeholder = "请输入";
                    } else if (newFormItem.prop.startsWith("extF")) {
                      newFormItem.component = "rc-input-number";
                      newFormItem.attribute.controlsPosition = "right";
                      newFormItem.attribute.precision = 2;
                      newFormItem.attribute.placeholder = "请输入";
                    } else if (newFormItem.prop.startsWith("extD")) {
                      newFormItem.component = "rc-date-picker";
                      newFormItem.attribute.placeholder = "请选择日期";
                    }
                  }

                  break;
                }
                default: {
                  newFormItem[field] = this.extFieldAddDialog.model[field];
                }
              }
            }
          });

          newFormItem.span = 8;
          if (Object.keys(newFormItem.attribute).length === 0){
            delete newFormItem.attribute;
          }
          if (newFormItem.rules.length === 0){
            delete newFormItem.rules;
          }

          this.suspend.synchronizing = true;
          this.suspend.method = "add";
          this.suspend.effectRowIndex = NaN;

          const dataCopy = parser.parse(parser.stringify(this.data));
          dataCopy.push(newFormItem);
          dataCopy.sort((a, b) => a.sys_order - b.sys_order);
          dataCopy.forEach(row => {
            delete row.sys_mode;
            delete row.sys_backup;
            delete row.sys_order;
            delete row.sys_required;
          });
          const resourceConfigCopy = this.getResourceConfigCopy();
          resourceConfigCopy.componentAttributesMap[this.com.id].formItem = dataCopy;

          const formData = resourceConfigCopy.componentAttributesMap[this.com.id].data;
          if (formData && !$isEmptyObject(formData)) {
            formData[newFormItem.prop] = "";
          }

          this.saveConfig({
            content: parser.stringify(resourceConfigCopy),
            succCallback: this.saveSuccCallback,
            failedCallback: this.saveFailedCallback
          });
        }
      });
    }
  }
};
</script>

<style scoped lang="scss">
  @import "style";
</style>
